import {gettext} from 'topmeteo/utils/i18n';

import TextItem from './TextItem';

const Text = gettext('Find a place. Either by name or by coordinates (e.g. "52.5, 13.4").');

const HelpText = () => <TextItem text={Text} className="help-text" />;

export default HelpText;
